/**
 * Escape special characters in order to pass a string to the RegExp constructor.
 * @param s a string.
 * @returns a string with special characters escaped.
 */
const escapeRegExp = (s: string): string => String(s).replace(/[\\^$*+?.()|[\]{}]/g, '\\$&');

export default escapeRegExp;
